import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { RefreshCw } from 'lucide-react';
import { Button } from '@bliks-io/ui';

interface PartnerPageHeaderProps {
  title: string;
  subtitle: string;
  /** Renders the shared refresh button wired to this handler. */
  onRefresh?: () => void;
  isRefreshing?: boolean;
  /** Extra actions rendered after the refresh button. */
  children?: ReactNode;
}

/** Shared partner-page header: title + subtitle on the left, actions on the right. */
export function PartnerPageHeader({
  title,
  subtitle,
  onRefresh,
  isRefreshing = false,
  children
}: PartnerPageHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">{title}</h1>
        <p className="text-sm text-muted-foreground">{subtitle}</p>
      </div>
      <div className="flex items-center gap-2">
        {onRefresh && (
          <Button
            variant="outline"
            onClick={onRefresh}
            loading={isRefreshing}
            disabled={isRefreshing}
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            {t('partner.common.refresh')}
          </Button>
        )}
        {children}
      </div>
    </div>
  );
}
